import { useTaskLocale } from '../../hooks';
import { PlanTaskReferencePickerPlugin } from '../../types';

const PlanTaskPluralText: PlanTaskReferencePickerPlugin['PluralText'] = ({
  lowerCase = false,
}) => {
  const { T } = useTaskLocale();
  const result = T.translate('PLAN_TASKS');

  if (lowerCase && typeof result === 'string') {
    return result.toLowerCase();
  }

  return result;
};

export default PlanTaskPluralText;
